import React from 'react';
import { Box } from '@usealloy/component-library';
import styled from 'styled-components';

interface ContainerProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const StyledBox = styled(Box)`
  && {
    @media (max-width: 767px) {
      flex-direction: column;
    }
  }
`;

const StyledCol = styled(Box)`
  && {
    @media (min-width: 767px) {
      max-width: 50%;
    }
  }
`;

export const Container: React.FC<ContainerProps> = ({ children, ...rest }) => (
  <Box
    className="evaluation-detail"
    direction="column"
    gap={5}
    {...rest}
  >
    {children}
  </Box>
);

export const Row: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <StyledBox
    gap={5}
    alignItems="flex-start"
  >
    {children}
  </StyledBox>
);

export const Col: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <StyledCol
    direction="column"
    gap={5}
    alignItems="flex-start"
  >
    {children}
  </StyledCol>
);
